import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Buttons from "../../components/Button/Button";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import CustomerDashboard from "../../components/CustomerDashboard/CustomerDashboard";
import "./Dashboard.scss";
import OrderProductRow from "../../components/Orderrow/Orderproductrow";
import { campaignData } from "../../store/action";
const OrderProduct = (props) => {
	const { t } = useTranslation();
	const history = useHistory();
	const data = props.location.state.items;
	return (
		<div className="home">
			<div className="left">
				<CustomerDashboard />
			</div>
			<div className="right">
				<div className="order">
					<div className="order-left" style={{ width: "100%" }}>
						<div className="head">
							<div>
								<h2>{t("payment")}</h2>
							</div>
							<div>
								<Buttons
									text={t("add-another")}
									style={{ width: "140px" }}
									onClick={() => history.goBack()}
								/>
							</div>
						</div>
						<div className="tail">
							<table
								style={{ width: "100%", textAlign: "left" }}
								CELLSPACING="0"
								CELLPADDING="0"
							>
								<thead>
									<tr>
										<th style={{ paddingLeft: "10px" }}>{t("product")}</th>
										<th>{t("color")}</th>
										<th>{t("size")}</th>
										<th>{t("quantity")}</th>
										<th>{t("price")}</th>
										<th>{t("total")}</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>
											<hr />
										</td>
										<td>
											<hr />
										</td>
										<td>
											<hr />
										</td>
										<td>
											<hr />
										</td>
										<td>
											<hr />
										</td>
										<td>
											<hr />
										</td>
									</tr>
									{data.map((data, ind) => {
										return (
											data.quantity !== 0 && <OrderProductRow data={data} />
										);
									})}
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
export default OrderProduct;
